import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
export var IconWrapper = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    bottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column-reverse',
    position: 'absolute',
    right: theme.spacing(2),
    zIndex: 1,
    gap: theme.spacing(1)
  }, theme.breakpoints.up('sm'), {
    gap: theme.spacing(2)
  });
});
//# sourceMappingURL=styles.js.map